import { HttpClient, type IHttpClient } from "@/services/HttpClient";
import type { IpoInfo } from "../interfaces/IpoInfo";
import type { Ipos } from "../interfaces/Ipos";

export class IpoService {
	private constructor(private httpClient: IHttpClient) {}

	private static instance: IpoService;

	static create() {
		if (!IpoService.instance) {
			IpoService.instance = new IpoService(HttpClient.create());
		}
		return IpoService.instance;
	}

	async getData(ticker: string): Promise<IpoInfo | null> {
		const { data } = await this.httpClient.get<Ipos>(
			`/ipos?ticker=eq:${ticker}`,
		);
		if (data.data.length === 0) {
			return null;
		}
		return data.data[0];
	}
}
